import { useQuery, type QueryClient } from '@tanstack/react-query'
import { type AxiosError, type AxiosInstance } from 'axios'
import { useSearch, useRouteContext } from '@tanstack/react-router'
import { DEFAULT_ORGANIZATION_ID } from '../components/overview/channel-filter'

export interface IntentBreakdownItem {
    id: number
    name: string
    ticket_count: number
    average_csat: number | null
    coverage_percentage: number
}

const BASE_QUERY_KEY = ['intent-breakdown'] as const

export const getIntentBreakdownQueryKey = (organizationId: number) => {
    return [...BASE_QUERY_KEY, organizationId] as const
}

export const fetchIntentBreakdown = async (api: AxiosInstance, organizationId: number): Promise<IntentBreakdownItem[]> => {
    const response = await api.get<IntentBreakdownItem[]>(
        `console/organization/${organizationId}/intent-breakdown`
    )
    return response.data
}

export const useIntentBreakdownQuery = () => {
    const { api } = useRouteContext({ from: '/_app/playbook' })
    const search = useSearch({ from: '/_app/playbook' })
    const organizationId = (search.organizationId as number | undefined) ?? DEFAULT_ORGANIZATION_ID
    return useQuery<IntentBreakdownItem[], AxiosError, IntentBreakdownItem[]>({
        queryKey: getIntentBreakdownQueryKey(organizationId),
        queryFn: () => fetchIntentBreakdown(api, organizationId),
        staleTime: Infinity,
    })
}

export const intentBreakdownLoader = (queryClient: QueryClient, api: AxiosInstance, organizationId: number) => {
    return queryClient.ensureQueryData({
        queryKey: getIntentBreakdownQueryKey(organizationId),
        queryFn: () => fetchIntentBreakdown(api, organizationId),
    })
}
